import React from 'react'
import { useNavigate } from 'react-router-dom'
import { FileQuestion, ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/Button'

export default function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ background: 'var(--cloud)' }}
    >
      <div className="text-center max-w-sm">
        <div
          className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6"
          style={{ backgroundColor: 'var(--accent-50)' }}
        >
          <FileQuestion size={36} style={{ color: 'var(--accent)' }} />
        </div>
        <h1 className="text-5xl font-bold text-navy dark:text-slate-100 mb-3">404</h1>
        <h2 className="text-lg font-semibold text-navy dark:text-slate-100 mb-2">
          Page not found
        </h2>
        <p className="text-sm text-steel dark:text-slate-400 mb-6">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Button
            variant="secondary"
            onClick={() => navigate(-1)}
            icon={<ArrowLeft size={14} />}
          >
            Go back
          </Button>
          <Button variant="primary" onClick={() => navigate('/dashboard')}>
            Dashboard
          </Button>
        </div>
      </div>
    </div>
  )
}
